import { objectHasFields } from 'src/utils/aem-utils/utils';
import { ValidationOutcomes, ValidationResult } from '.';

const ValidateGlobalAlertBannerComponentProps = (
  props: any,
): ValidationResult => {
  let vr: ValidationResult = {
    result: ValidationOutcomes.UNKNOWN,
    messages: [],
  };

  if (!objectHasFields(props, ['text'])) {
    vr.messages.push('Global Alert Banner is missing text');
    vr.result = ValidationOutcomes.FAILURE;
    return vr;
  }

  const componentProps = { ...props };
  const linkHref =
    typeof componentProps.linkHref === 'string'
      ? componentProps.linkHref.trim()
      : componentProps.linkHref;

  if (typeof linkHref === 'string') componentProps.linkHref = linkHref;
  if (typeof componentProps.linkText === 'string')
    componentProps.linkText = componentProps.linkText.trim();

  const hasValidLinkHref =
    typeof linkHref === 'string' ? linkHref.length > 0 : Boolean(linkHref);
  if (!hasValidLinkHref) {
    delete componentProps.linkHref;
    delete componentProps.linkText;
  }

  vr.componentProps = componentProps;
  vr.result = ValidationOutcomes.SUCCESS;
  return vr;
};

export default ValidateGlobalAlertBannerComponentProps;
